import { FormGroup } from "@angular/forms";

export const trimValues = (form: FormGroup<any>) => {
  Object.entries(form.controls).forEach(([key, control]) => {
    const value = control.value;

    if (!!value && typeof value === "string") {
      form.get(key)?.patchValue(value.trim());
    }
  });
};
